import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight, Info } from 'lucide-react';
import { getServiceIcon } from '../../utils/serviceIcons';
import { Button } from './Button';
import { Modal } from './Modal';
import './ServiceOfferCard.css';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Carte de présentation d'un service, de taille uniforme (titre/description tronqués).
 * "En savoir plus" ouvre un modal avec le détail complet ; le CTA principal mène au devis.
 */
export function ServiceOfferCard({ service, categorieNom, tone = 'primary' }) {
  const Icon = getServiceIcon(service.titre);
  const [detailOuvert, setDetailOuvert] = useState(false);

  return (
    <article className={`offer-card ${service.mise_en_avant ? 'offer-card--featured' : ''}`}>
      {service.mise_en_avant === 1 || service.mise_en_avant === true ? (
        <span className="offer-card__ribbon">
          <Star size={13} strokeWidth={2.5} /> Recommandé
        </span>
      ) : null}

      <div className={`offer-card__media offer-card__media--${tone}`}>
        {service.image_url ? (
          <img src={`${API_URL}${service.image_url}`} alt={service.titre} loading="lazy" />
        ) : (
          <Icon className="offer-card__media-icon" strokeWidth={1.5} />
        )}
        {categorieNom && <span className="offer-card__tag">{categorieNom}</span>}
      </div>

      <div className="offer-card__body">
        <h3 className="offer-card__title">{service.titre}</h3>
        <p className="offer-card__desc">{service.description_courte || service.description}</p>

        <div className="offer-card__actions">
          <button type="button" className="offer-card__more" onClick={() => setDetailOuvert(true)}>
            <Info size={14} /> En savoir plus
          </button>
          <Link to="/devis" className="offer-card__cta">
            <Button variant={tone === 'secondary' ? 'secondary' : 'primary'} className="offer-card__cta-btn">
              Demander un devis <ArrowRight size={15} />
            </Button>
          </Link>
        </div>
      </div>

      <Modal open={detailOuvert} onClose={() => setDetailOuvert(false)} ariaLabel={service.titre}>
        <div className="offer-modal">
          <div className={`offer-modal__media offer-modal__media--${tone}`}>
            {service.image_url ? (
              <img src={`${API_URL}${service.image_url}`} alt={service.titre} />
            ) : (
              <Icon className="offer-modal__media-icon" strokeWidth={1.5} />
            )}
          </div>
          <div className="offer-modal__body">
            {categorieNom && <span className="offer-modal__tag">{categorieNom}</span>}
            <h2>{service.titre}</h2>
            {service.description_courte && <p className="offer-modal__intro">{service.description_courte}</p>}
            {service.description && <p className="offer-modal__desc">{service.description}</p>}
            <Link to="/devis">
              <Button className="offer-modal__cta">
                Demander un devis <ArrowRight size={16} />
              </Button>
            </Link>
          </div>
        </div>
      </Modal>
    </article>
  );
}
